<app-course-header></app-course-header>

<div class="UNFAPP-signlog-full-area">
    <div class="UNFAPP-signlog-frm-wrpbx">
        <div class="UNFAPP-signlog-frmbx">
            <div class="UNFAPP-signlog-hdng-wrap">
                <h2 class="UNFAPP-signlog-hdng">Welcome to Infinity Learn</h2>
                <h3 class="UNFAPP-signlog-stphdng">You are 2 steps away from starting your learning journey</h3>
                <!-- <h3 class="UNFAPP-acnt-link-hdng">I already have an account <a href="#">Click here</a></h3> -->
            </div>

            <div class="UNFAPP-signlog-tabarea">
                <div class="UNFAPP-signlog-tab-btn-area">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" routerLink='/signup'>Sign up</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link active" data-toggle="tab" href="#signin" role="tab">Sign in</a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content" id="myTabContent">
                    <!-- signup -->
                    <div class="tab-pane fade" id="signup" role="tabpanel">
                        <div class="UNFAPP-tab-wrap">
                            <div class="UNFAPP-signlog-form-area">

                                <div class="UNFAPP-form-fld-row">
                                    <div class="UNFAPP-form-fld-wrp UNFAPP-phncuntry-drpdwn UNFAPP-wthicon">
                                        <span class="UNFAPP-frmicon"><img src="assets/img/phone-icon.png"
                                                alt="" /></span>
                                        <div class="UNFAPP-phncuntry-fldgrp">
                                            <select>
                                                <option>+91</option>
                                                <option>+91</option>
                                                <option>+91</option>
                                                <option>+91</option>
                                                <option>+91</option>
                                            </select>
                                            <input type="text" placeholder="Phone Number" />
                                        </div>
                                    </div>
                                    <label class="UNFAPP-fld-error">*Account already exists, please click on login to
                                        continue</label>
                                </div>


                                <div class="UNFAPP-form-fld-row">
                                    <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon">
                                        <span class="UNFAPP-frmicon"><img src="assets/img/name-icon.png"
                                                alt="" /></span>
                                        <input type="text" class="UNFAPP-form-fld" placeholder="First Name">
                                    </div>
                                </div>
                                <div class="UNFAPP-form-fld-row">
                                    <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon">
                                        <span class="UNFAPP-frmicon"><img src="assets/img/name-icon.png"
                                                alt="" /></span>
                                        <input type="text" class="UNFAPP-form-fld" placeholder="Last Name">
                                    </div>
                                </div>
                                <div class="UNFAPP-signlog-grdarea">
                                    <h3 class="UNFAPP-signlog-hdng lightbold sm-hdng">What grade are you in?</h3>
                                    <ul class="UNFAPP-grdlist-area">
                                        <li>
                                            <label class="UNFAPP-grd-radio">
                                                <input type="radio" name="grade">
                                                <div class="UNFAPP-grd-radiobx">9th</div>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="UNFAPP-grd-radio">
                                                <input type="radio" name="grade">
                                                <div class="UNFAPP-grd-radiobx">10th</div>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="UNFAPP-grd-radio">
                                                <input type="radio" name="grade">
                                                <div class="UNFAPP-grd-radiobx">11th</div>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="UNFAPP-grd-radio">
                                                <input type="radio" name="grade">
                                                <div class="UNFAPP-grd-radiobx">12th</div>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="UNFAPP-grd-radio">
                                                <input type="radio" name="grade">
                                                <div class="UNFAPP-grd-radiobx">13th</div>
                                            </label>
                                        </li>
                                    </ul>
                                </div>


                                <div class="UNFAPP-update-txt text-center">
                                    <label class="whtapp-custom-checkbox">
                                        <input type="checkbox"><span>Receive updates on Whatsapp</span>
                                    </label>
                                </div>
                                <p class="UNFAPP-terms-text">By signing up you agree to our <a href="#">T&C</a> and <a
                                        href="#">Privacy
                                        Policy</a>
                                </p>

                                <div class="UNFAPP-frm-actn-area">
                                    <button class="UNFAPP-blue-btn UNFAPP-full-btn">Get OTP</button>
                                </div>


                            </div>
                        </div>
                    </div>
                    <!-- register -->
                    <div class="tab-pane fade show active" id="signin" role="tabpanel">
                        <div class="UNFAPP-tab-wrap">
                            <div class="UNFAPP-loginvia-sectn smsp">
                                <div class="UNFAPP-otp-img nogap">
                                    <img src="assets/img/otp-icon.svg" alt="" />
                                </div>
                                <div class="UNFAPP-loginvia-hdngarea UNFAPP-verify">
                                    <h3 class="UNFAPP-loginvia-hdng">Phone Number Verified</h3>
                                    <h4 class="UNFAPP-loginvia-subhdng">Please set a new password for your account</h4>
                                </div>
                                <div class="UNFAPP-loginvia-fromarea" [formGroup]='passwordForm'>
                                    <div class="UNFAPP-form-fld-row">
                                        <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon">
                                            <span class="UNFAPP-frmicon"><img src="assets/img/password-lock.svg"
                                                    alt="" /></span>
                                            <span class="UNFAPP-frm-eyeicon" (click)='show_button1 = !show_button1'>
                                                <img *ngIf='show_button1' src="assets/img/eye-slash.svg" alt="">
                                                <img *ngIf='!show_button1' src="assets/img/eye-icon.svg" alt="">
                                            </span>

                                            <input [type]="show_button1 ? 'text' : 'password'" oncopy="return false"
                                                onpaste="return false" class="UNFAPP-form-fld" placeholder="New Password"
                                                formControlName='password'>
                                        </div>
                                        <label class="UNFAPP-fld-error"
                                            *ngIf="pwd.password.touched && pwd.password.errors?.required">*Required</label>
                                        <mat-error class="UNFAPP-fld-error"
                                            *ngIf="pwd.password.touched && pwd.password.errors?.minlength">
                                            *Password should be atleast 6 characters
                                        </mat-error>
                                    </div>
                                    <div class="UNFAPP-form-fld-row">
                                        <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon">
                                            <span class="UNFAPP-frmicon"><img src="assets/img/password-lock.svg"
                                                    alt="" /></span>
                                            
                                            <span class="UNFAPP-frm-eyeicon" (click)='show_button2 =!show_button2'>
                                                <img *ngIf='show_button2' src="assets/img/eye-slash.svg" alt="">
                                                <img *ngIf='!show_button2' src="assets/img/eye-icon.svg" alt="">
                                            </span>

                                            <input [type]="show_button2 ? 'text' : 'password'" oncopy="return false"
                                                onpaste="return false" class="UNFAPP-form-fld" placeholder="Confirm New Password"
                                                formControlName='confirmPassword'>
                                        </div>
                                        <label class="UNFAPP-fld-error"
                                            *ngIf="pwd.confirmPassword.touched && pwd.confirmPassword.errors?.required">*Required</label>
                                        <span *ngIf="pwd.confirmPassword.touched && pwd.confirmPassword.invalid">
                                            <mat-error class="UNFAPP-fld-error"
                                                *ngIf=" pwd.confirmPassword.errors.confirmedValidator  ">
                                                *Password must be same
                                            </mat-error>
                                        </span>
                                    </div>
                                    <div class="UNFAPP-loginvia-actnarea">
                                        <button type="button" class="UNFAPP-blue-btn UNFAPP-full-btn"
                                            [disabled]='!passwordForm.valid || (passwordForm.value.password != passwordForm.value.confirmPassword)'
                                            (click)='resetPassword()'>RESET PASSWORD</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<app-course-footer></app-course-footer>